import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const EditSessionPage = ({
  initialData,
  onSuccess,
  onError,
  date,
  session,
}) => {
  const API_URL = "/trip-availability"; // Endpoint untuk sesi
  // console.log("EditSessionPage session", session);

  // State form untuk menyimpan nama sesi dan jumlah ATV
  const [formData, setFormData] = useState({
    sessionName: session.name,
    trip_id: session.id,
    date: date,
    availability: session.availability,
  });

  // Apakah ini dalam mode edit?
  const isUpdateMode = !!initialData;

  // hook untuk create
  const { createData: createSession, loading: creatingSession } = useCreateData(
    API_URL,
    "trip-availability"
  );

  // Hook untuk update data
  const { updateData: updateSession, loading: updatingSession } = useUpdateData(
    `${API_URL}/${session?.id}`,
    "trip-availabilitys"
  );
  // const { updateData: updateSession, loading: updatingSession } = useUpdateData(
  //   `${API_URL}/${initialData?.id}`,
  //   "trip-availability"
  // );

  // Gunakan handler bawaan untuk perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Handler untuk submit data
  // const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
  //   updateSession,
  //   onSuccess,
  //   onError
  // );

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateSession : createSession,
    onSuccess,
    onError
  );

  // Fungsi untuk submit dengan payload
  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };
    handleSubmit(payload, e);
  };

  // Jika ada `initialData`, isi form dengan data awal
  useEffect(() => {
    if (initialData) {
      setFormData({
        sessionName: initialData.sessionName || "",
        availability: initialData.availability || 0,
      });
    }
  }, [initialData]);

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/* Nama Sesi */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="sessionName"
            className="col-sm-4 col-form-label text-end"
            style={{ fontSize: "14px" }}
          >
            Nama Sesi:
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.sessionName && "is-invalid"
              )}
              id="sessionName"
              placeholder="Nama Sesi"
              name="sessionName"
              value={formData.sessionName}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.sessionName && (
              <div className="invalid-feedback">{formError.sessionName}</div>
            )}
          </div>
        </div>

        {/* date */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="date"
            className="col-sm-4 col-form-label text-end"
            style={{ fontSize: "14px" }}
          >
            Tanggal:
          </label>
          <div className="col-sm-8">
            <input
              type="date"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.date && "is-invalid"
              )}
              id="date"
              placeholder="Tanggal"
              name="date"
              value={formData.date}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.date && (
              <div className="invalid-feedback">{formError.date}</div>
            )}
          </div>
        </div>

        {/* Jumlah ATV Tersedia */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="availability"
            className="col-sm-4 col-form-label text-end"
            style={{ fontSize: "14px" }}
          >
            Ketersediaan ATV:
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.availability && "is-invalid"
              )}
              id="availability"
              placeholder="Jumlah ATV Tersedia"
              name="availability"
              value={formData.availability}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
              min="0"
            />
            {formError?.availability && (
              <div className="invalid-feedback">{formError.availability}</div>
            )}
          </div>
        </div>
      </div>

      {/* Tombol Submit */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {
            isUpdateMode ? "Update Sesi" : "Update Sesi"
            // "Create Sesi"
          }
        </button>
      </div>
    </form>
  );
};

export default EditSessionPage;
